import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/$city/$district/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/kaart',
      search: { city: params.city, district: params.district },
      replace: true,
    });
  },
});
